import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';

interface LanguageState {
  selectedLanguage: string;
}

const loadLanguage = (): string => {
  return localStorage.getItem('selectedLanguage') || 'de';
};

const initialState: LanguageState = {
  selectedLanguage: loadLanguage(),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      localStorage.setItem('selectedLanguage', action.payload);
      i18n.changeLanguage(action.payload);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer; 